import { Card, useWindowWidth } from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { MOBILE_WIDTH } from '@/constants';
import { ChannelType } from '@/features/broadcasters/types';

import { ParentBroadcastersDetail } from './components';

type ParentBroadcasteretailsCardProps = {
  parentBroadcaster: ChannelType;
  isCollapsed: boolean;
  onCollapse: () => void;
  onUpdate: (parentBroadcaster: ChannelType) => void;
};

export function ParentBroadcastersDetailCard({
  onCollapse,
  isCollapsed,
  parentBroadcaster,
  onUpdate,
}: ParentBroadcasteretailsCardProps) {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      className="w-full"
      title={parentBroadcaster.name}
      isAccordion={isMobile}
      isCollapsable={!isMobile}
      isOpen={isOpen}
      collapseDirection="right"
      lineSeparator={true}
      isCollapsed={isCollapsed && !isMobile}
      onCollapse={onCollapse}
      onOpen={() => setIsOpen(!isOpen)}
      classes={{
        header: clsx(!isMobile && 'py-3'),
      }}
    >
      <div className="body flex flex-col gap-size-12 self-stretch">
        <ParentBroadcastersDetail parentBroadcaster={parentBroadcaster} onUpdate={onUpdate} />
      </div>
    </Card>
  );
}
